module.exports = __webpack_public_path__ + "img/link-45deg.9a411c14.svg";